let animation = gsap.timeline();

function logoInit() {
  gsap.set(".whey", {autoAlpha:1})
  let divs = document.querySelectorAll(".whey div");
  animation.from(divs, {y:35, opacity:0, stagger:0.2})
           .to(divs, {y: function(index, target) {
              if (index < divs.length - 1) {
                return -35;
              }
              return 0;
            }, opacity: function(index, target) {
              if (index < divs.length - 1) {
                return 0;
              }
              return 1;
            }, stagger:0.2}, 0.05);
}

logoInit();

